import { useTranslation } from "react-i18next";
import { ChangeEvent, useCallback, useState } from "react";
import Dialog from "components/common/Dialog/Dialog";
import Button from "components/common/Button/Button";
import {
  ContainerButtonStyle,
  DeleteButtonsStyle,
  ImageContainerStyle,
  ImageStyle,
  InputStyle,
} from "./AddBrand.style";
import {
  IAddDialog,
  IBrandAddingData,
  IBrandAddingDataError,
} from "./AddBrand.types";
import { useSnackBar } from "hooks/useSnackBar";
import TextInput from "components/common/TextInput/TextInput";
import { useAddCategoryMutation } from "redux/api/category/category";
import FileInput from "components/common/FileInput/FileInput";
import { GlobalVariables } from "config/constant";
import { useNavigate } from "react-router-dom";
import { RouteIdEnum } from "config/enums";
import { useAddBrandMutation } from "redux/api/brand/brand";

function AddBrand({ openAddingDialog, setOpenAddingDialog,addFromProduct }: IAddDialog) {
  const { t } = useTranslation();

  const { displaySuccessSnackBar, displayErrorApiSnackBar } = useSnackBar();
  const navigate=useNavigate()
  const [addingError, setAddingError] =
    useState<IBrandAddingDataError>({
      name: "",
      image: "",
    });
  const [addingBrand, { data, error, isLoading, reset }] =
    useAddBrandMutation();

  if (error) {
    displayErrorApiSnackBar(error);
    reset();
  }
  if (data) {
    displaySuccessSnackBar(t("brand.successfully_adding"));
    reset();
    // !addFromProduct ?navigate("/" + RouteIdEnum.Brand):navigate("/products/add");

  }
  const [addingData, setAddingData] = useState<IBrandAddingData>({
    name: "",
    image: null,
  });
  const closeAddingDialog = useCallback(() => {
    setOpenAddingDialog(false);
    setAddingData({ name: "", image: null });
    setAddingError({ name: "", image: "" });
  }, [setOpenAddingDialog]);
  const validate=()=>{
    const addingErrorCateg:{name:string,image:string}={
      name:"",
      image:"",
    }
    if(!addingData.name){
      addingErrorCateg.name="Nom obligatoire"
    }
    else {
      addingErrorCateg.name=""

    }
    if(!addingData.image){
      addingErrorCateg.image="Image obligatoire"

    }
    else{
      addingErrorCateg.image=""

    }
    setAddingError(addingErrorCateg)
    console.log("AddingError",addingErrorCateg)

  }
  const onChangeOneImage = useCallback(
    (field: string) => (e: any) => {
      const files = (e.target as HTMLInputElement).files;

      if (files) {
        const file = files[0];

        // Check if the selected file is an image
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();

          reader.onload = (event) => {
            if (event.target) {
              const image = new Image();
              image.src = event.target.result as string;

              image.onload = () => {
                // Access the image dimensions
                const imageWidth = image.width;
                const imageHeight = image.height;

                console.log('Image Width:', imageWidth);
                console.log('Image Height:', imageHeight);
                if(imageWidth==300 && imageHeight == 300){
                  setAddingError({ ...addingError, image: "" });

                  setAddingData({
                    ...addingData,
                  image : e.target.files[0]})


                }else{
                  setAddingError({ ...addingError, image: "L'image doit être de taille 300 × 300 pixels." });

                }


              };
            }
          };

          // Read the selected file as a data URL
          reader.readAsDataURL(file);
        } else {
          // Handle non-image file type
          console.error('Selected file is not an image.');
        }
      }
    },
    [addingData,addingError]
  );
  const onSuccessAddingDialog = (event: React.FormEvent) => {
    event.preventDefault();
    validate()
    const formData = new FormData();
    formData.append("name", addingData.name);
    if (addingData.image) formData.append("image", addingData.image);
    if(addingData.name&& addingData.image){
    addingBrand(formData);
    closeAddingDialog();
    }
  };



  const onChange = useCallback(
    (field: string) =>
      (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        validate()
        setAddingData({ ...addingData, [field]: e.target.value });
        if (field === "image") {
          const files = (e.target as HTMLInputElement).files;
          if (files)
            setAddingData({
              ...addingData,
              image: files[0],
            });
        }
    
      },
    [addingData]
  );

  return (
    <Dialog
      open={openAddingDialog}
      handleClose={closeAddingDialog}
      title={t("brand.add")}
    >
      <form onSubmit={onSuccessAddingDialog}>
        <InputStyle>
          <TextInput
            value={addingData.name}
            label={t("brand.name")}
            onChange={onChange("name")}
            error={t(addingError.name)}
          />
        </InputStyle>
        <InputStyle>
          <FileInput
            value={addingData.image}
            label={t("brand.image")}
            onChange={onChangeOneImage("image")}
            error={t(addingError.image)}
            accept={GlobalVariables.FILE_FORMATS.map((e) => e.format).join(",")}
          />
        </InputStyle>
        {addingData.image && (
          <ImageContainerStyle>
            <ImageStyle
              src={URL.createObjectURL(addingData.image)}
            ></ImageStyle>
          </ImageContainerStyle>
        )}
        <DeleteButtonsStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              title={t("common.cancel_button")}
              onClick={closeAddingDialog}
            />
          </ContainerButtonStyle>
          <ContainerButtonStyle>
            <Button
              disabled={isLoading}
              type="submit"
              loader={isLoading}
              title={t("common.confirm_button")}
            />
          </ContainerButtonStyle>
        </DeleteButtonsStyle>
      </form>
    </Dialog>
  );
}
export default AddBrand;
